import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { openThread as openThreadClient } from '../clients/openThread';
import { OPEN_THREAD } from '../constants/asyncActionTypes';
export const openThread = createAsyncAction({
  requestFn: openThreadClient,
  actionTypes: OPEN_THREAD,
  toRecordFn: response => response
});